import { Col, DatePicker, Input, Row, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";

import { enumFieldType } from "../../constant/WebToLead";

const CustomFields = ({
  wtlCustomFields,
  onChange,
  title = "Custom Fields",
}) => {
  return (
    <>
      {!!wtlCustomFields?.length && (
        <div className="heading18px w-100 fw-semibold tw-mt-[30px] tw-mb-[20px] tw-py-[5px]">
          {title}
        </div>
      )}
      {wtlCustomFields?.map((data, i) => (
        <Row key={i} className="justify-content-between mb15">
          <Col xs={24} md={4}>
            <label className="tw-text-sm tw-font-medium">
              {data?.fieldName}
            </label>
          </Col>
          <Col xs={24} md={19}>
            <RenderComponent
              fieldType={data?.fieldType}
              fieldValue={data?.fieldValue}
              onChange={(value) => onChange(data?.fieldName, value)}
              pickValues={data?.pickValues?.map((option) => {
                const val =
                  typeof option === "object"
                    ? option.pickValue || option.value
                    : option;
                return {
                  label: val,
                  value: val,
                };
              })}
            />
          </Col>
        </Row>
      ))}
    </>
  );
};

export const RenderComponent = ({
  fieldType,
  fieldValue,
  value,
  fieldName,
  onChange,
  pickValues,
}) => {
  const renderSwitch = (type) => {
    const currentValue = value !== undefined ? value : fieldValue;

    switch (type) {
      case enumFieldType.TEXT:
        return (
          <Input
            name={fieldName}
            value={currentValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.CURRENCY:
        return (
          <Input
            name={fieldName}
            value={currentValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.TEXT_AREA:
        return (
          <TextArea
            name={fieldName}
            value={currentValue}
            rows={2}
            maxLength={500}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.INTEGER:
        return (
          <Input
            name="number"
            type="number"
            value={currentValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.EMAIL:
        return (
          <Input
            name="email"
            value={currentValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.PHONE:
        return (
          <Input
            name="phone"
            type="number"
            min={0}
            max={20}
            value={currentValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.URL:
        return (
          <Input
            name="url"
            value={currentValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.PICK_LIST:
        return (
          <Select
            value={currentValue}
            className="tw-w-full"
            options={pickValues}
            onChange={(value) => onChange(value)}
          />
        );
      case enumFieldType.MULTI_PICK_LIST:
        return (
          <Select
            mode="multiple"
            className="tw-w-full"
            placeholder="Please select"
            value={
              typeof currentValue === "string" &&
              currentValue?.split(", ")?.filter((d) => d !== "")?.length
                ? currentValue?.split(", ")?.filter((d) => d !== "")
                : Array.isArray(currentValue)
                  ? currentValue
                  : !!currentValue?.length
                    ? [currentValue]
                    : []
            }
            onChange={(value) => onChange(value?.join(", "))}
            options={pickValues}
          />
        );
      case enumFieldType.DATE:
        return (
          <DatePicker
            value={currentValue ? dayjs(currentValue) : null}
            onChange={(date) => onChange(dayjs(date).format())}
          />
        );
      default:
        return <></>;
    }
  };

  return <div>{renderSwitch(fieldType)}</div>;
};

export default CustomFields;
